<template>
  <MModal
    @close="$emit('close')"
    modal-class="md:max-w-lg"
    backdrop-override-class="bg-amber-800/65"
  >
    <div class="overflow-hidden md:overflow-visible">
      <div class="relative flex px-6 md:px-0 pb-20 pt-24 md:pt-8 md:pb-16">
        <div class="pr-24 md:pr-8 md:pl-36">
          <p class="subtitle1">{{ $t('app_prompt.download_the_app') }}</p>
          <div class="grid grid-cols-1 gap-y-4 w-full items-center mt-6 text-18 font-medium">
            <SellingPoints :items-to-display="2" />
          </div>
        </div>
        <div class="absolute py-4 md:py-0 h-full top-4 -right-12 md:right-0 md:-left-6 md:-top-6">
          <img
            src="../images/simple-app-screen.png"
            class="h-full drop-shadow-4 -rotate-[5deg]"
            alt=""
            loading="lazy"
          />
        </div>
      </div>

      <div class="flex gap-x-6 justify-center mb-6 md:mb-0 md:mx-8">
        <StoreLinks :link @track-click="trackClick" />
        <img src="../images/app-qr.png" class="hidden md:block h-28" alt="" loading="lazy" />
      </div>
      <ScanMe class="hidden md:flex -mt-2 mb-4" />

      <div class="md:hidden mx-6 mb-8">
        <a
          class="btn btn-green w-full"
          :href="link"
          target="_blank"
          rel="nofollow noopener"
          @click="trackClick"
        >
          {{ $t('app_prompt.get_the_app') }}
        </a>
      </div>
    </div>
  </MModal>
</template>

<script lang="ts" setup>
import SellingPoints from '../selling-points.vue'
import StoreLinks from '../store-links.vue'
import ScanMe from '../scan-me.vue'
import { AppPromptClick } from '@core/analytics/core-events/app'

const { $track } = useNuxtApp()

const link = useAppLink('prompt_post_clickout')

defineEmits(['close'])

async function trackClick() {
  await $track(AppPromptClick('post_clickout'))
}
</script>
